import { lazy } from 'react';

export const ScheduleList = lazy(() => import('./schedule/ScheduleList'));
export const AddSchedule = lazy(() => import('./schedule/AddSchedule'));
export const UpdateSchedule = lazy(() => import('./schedule/UpdateSchedule'));
export const ScheduleFilter = lazy(() => import('./schedule/ScheduleFilter'));
